var _g, _filter;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210 265",
    role: "img",
    filter: "url(#grayscale)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, "meet") : title ? /*#__PURE__*/React.createElement("title", {
    lang: "en",
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M145.113 255.731s-3.74 3.465-12.268 5.635c-1.878.478-3.9-.16-3.9 2.934h10.347l8.607-1.487v1.487h4.647s1.296-7.595-1.418-8.569h-6.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M145.474 249.27l-.522 7.14c1.695 1.537 3.922 1.636 5.693.25l.32-.25 1.931-7.14h-7.422z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M185.303 255.731s-3.74 3.465-12.268 5.635c-1.877.478-3.9-.16-3.9 2.934h10.347l8.608-1.487v1.487h4.647s1.296-7.595-1.42-8.569h-6.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M185.827 249.517l-.523 7.14c1.695 1.537 3.922 1.636 5.694.25l.318-.25 1.932-7.14h-7.421z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M161.435 112.479H149.53l-4.183 137.848h8.044l23.636-112.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M157.574 112.479l27.827 137.848h8.855l-3.63-137.848z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8376F",
    d: "M180.703 146.567l2.67-.19c0-.01-.101-1.883 1.239-3.248 1.033-1.05 2.692-1.585 4.935-1.585 2.453 0 4.295.542 5.325 1.57 1.011 1.008.975 2.195.973 2.243l2.673.152c.013-.232.102-2.313-1.662-4.117-1.564-1.6-4.024-2.412-7.31-2.412-3.029 0-5.356.815-6.915 2.424-2.129 2.198-1.938 5.042-1.928 5.163"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M169.686 175.277h39.845v-25.613h-39.845z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0326F",
    d: "M188.152 166.93c0 1.562.742 1.74 1.661 1.74.92 0 1.663-.178 1.663-1.74v-5.434c11.481-1.195 18.056-3.23 18.056-3.23v20.202c0 1.807-.699 3.27-1.76 3.27h-36.327c-1.059 0-1.759-1.463-1.759-3.27v-20.136c8.316 1.93 8.859 1.97 18.466 3.125v5.473z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B8376F",
    d: "M171.445 144.17h36.326c1.062 0 1.76 1.462 1.76 3.266v9.801c-6.359 2.112-12.536 2.936-18.054 3.065v-1.325c0-1.562-.744-1.74-1.663-1.74-.92 0-1.661.178-1.661 1.74v1.32c-10.877-.28-18.468-3.06-18.468-3.06v-9.801c0-1.804.7-3.266 1.76-3.266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M188.353 162.385a.516.516 0 0 0-.516.515v1.681c0 .283.231.514.516.514h2.882a.514.514 0 0 0 .514-.514V162.9a.514.514 0 0 0-.514-.515h-2.882zm-.722 2.196V162.9c0-.398.325-.721.722-.721h2.882a.72.72 0 0 1 .72.72v1.682a.72.72 0 0 1-.72.72h-2.882a.721.721 0 0 1-.722-.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M189.61 163.55c0 .095.083.172.183.172.102 0 .186-.077.186-.172v-2.35c0-.095-.084-.173-.186-.173-.1 0-.184.078-.184.174v2.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M91.274 96.497c-.412.328-1.934 1.32-5.624 1.628-3.312.276-10.365-1.168-9.019 2.101 3.17 1.712 6.688 4.099 6.688 4.099 2.022.847 5.602-.033 7.727-1.002l6.18-3.768s.528-3.47.584-3.628l-1.415-.577a16.989 16.989 0 0 1-5.121 1.147"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M90.139 97.953s-.11.16-.367.396c.44.178.864.377 1.28.588 1.733.046 3.464.147 5.197.212-.105-1-.253-2.402-.246-2.503l-11.265-2.68s-.913 1.185 1.147 2.461c2.06 1.277 4.254 1.526 4.254 1.526m98.61 30.569l-3.744 8.224s.805 4.522 2.461 6.284c.5.53 1.288.674 1.961.396 1.56-.645 5.16-2.201 5.756-3.054.295-.424.338-.976.182-1.466l-1.09-3.624-.134-8.445-5.392 1.685z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F39F85",
    d: "M166.7 29.627l-.124 11.021 9.828-.53.621-17.083z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M165.06 30.644c-1.37-.036-2.645-.244-3.311-.786-3.96-5.753.552-21.267.552-21.267l6.33-2.663 8.045 5.014.457 10.396c.122 2.773-1.21 5.437-3.592 7.17-2.547 1.429-5.49 2.22-8.48 2.136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M174.443 16.833c-.442-1.747.753-5.777-1.025-5.484-1.3.212-5.749.394-7.246.394-3.569 0-9.929-1.395-9.929-6.818 0-2.712 1.668-4.088 3.336-4.783 1.638-.681 3.485 1.28 5.16 1.865 3.928 1.372 12.04 2.483 14.115 2.053 2.356-.489 4.821 1.913 5.002 3.349.398 3.145-1.707 7.938-3.267 10.968a16.679 16.679 0 0 1-3.564 4.657l-2.582-6.201z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M179.025 17.225c-.795-.701-2.282-.57-3.322.296-1.042.865-1.243 2.136-.446 2.837.796.701 2.283.569 3.323-.296 1.041-.865 1.242-2.136.445-2.837"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M162.741 38.046c-7.077 1.46-13.033 6.204-16.304 12.64 0 0-10.424 26.367-15.25 30.022-4.826 3.66-36.771 14.642-36.771 14.642v7.043s36.128-.614 45.137-6.86c9.011-6.249 9.976-13.016 9.976-13.016v29.963h37.275l-.911-46.46 1.286 65.04s4.504.322 8.045 0c12.018-27.591 6.777-59.063 3.652-72.33-1.988-8.43-7.608-15.688-15.54-19.18-3.219-1.417-7.047-2.362-11.535-2.362-3.49 0-6.49.33-9.06.858"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M186.286 112.737l-.876-44.77.965-.029.886 44.799zM176.59 34.05l.605 3.62-11.296-.02.74-3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M29.384 63.528s.343 41.152 11.082 40.662c10.74-.49 17.81-32.98 17.81-32.98l-4.35-1.276-10.422 19.654s1.562-6.404-1.082-18.192c-2.644-11.787-13.038-7.868-13.038-7.868"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M53.73 70.694l-1.923-7.835s1.453-3.834 3.197-5.107c.525-.385 1.24-.38 1.786-.023 1.261.823 4.163 2.782 4.545 3.63.188.418.136.91-.082 1.315l-1.556 3-1.421 5.537-4.545-.517z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED7577",
    d: "M19.67 53.218c7.586 0 9.364 1.109 9.364 1.109s9.726 12.045 13.114 19.838c1.268 2.912 1.288 6.242-.049 9.124-5.975 12.862-5.214 37.628-5.214 37.628H14.72c.983-18.457-18.087-64.194 4.949-67.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M46.823 250.943l1.35 4.578a5.186 5.186 0 0 0 2.122 3.043c1.168.791 3.019 1.773 5.827 2.626-3.801 3.01-9.145-.01-12.157-2.233-1.47-1.083-2.43-2.7-2.73-4.546l-.424-3.468h6.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E206C",
    d: "M40.864 252.385s-2.554 1.874-2.335 4.265c.223 2.389.339 7.985.339 7.985h2.453l.397-5.22c.037-.341 4.792 5.22 5.682 5.22h12.99s1.18-3.52-6.346-4.653c-7.524-1.132-13.18-7.597-13.18-7.597"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2B2B",
    d: "M36.885 120.917L47.55 251.434l-7.273.15S26.831 224.151 26.54 201.41c-.048-3.759.12-7.585-2.078-10.46-16.764-21.928-8.306-56.567-8.306-56.567l11.35-13.467h9.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M7.634 250.943l1.76 4.578a5.882 5.882 0 0 0 2.398 3.043c1.239.791 3.178 1.773 6.063 2.626-3.528 3.01-9.145-.01-12.358-2.233a7.85 7.85 0 0 1-3.14-4.546l-.737-3.468h6.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E206C",
    d: "M2.003 252.385s-2.387 1.874-1.95 4.265c.44 2.389 1.057 7.985 1.057 7.985h2.455l-.075-5.22c.006-.341 5.263 5.22 6.152 5.22h12.99s.864-3.52-6.764-4.653c-7.626-1.132-13.865-7.597-13.865-7.597"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F39F85",
    d: "M30.154 48.016l.02 14.524-8.726-9.504.94-13.517z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M31.606 26.795c-6.044.82-9.051 8.562-9.051 8.562l.069 22.91-10.482-9.054s-.76-10.336 1.826-21.598c2.242-7.09 11.288-8.957 17.638-5.499 3.09 1.683 4.923 4.985 6.015 8.264 1.464 4.402 1.593 9.14.622 13.677l-3.596 16.811-4.473-4.431s-1.148-4.291-.02-8.42c2.303-8.437 5.511-21.772 1.452-21.222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M20.775 35.678c.677-.656 1.946-.53 2.832.278.887.806 1.057 1.994.38 2.65-.678.655-1.946.53-2.833-.278-.888-.807-1.055-1.994-.379-2.65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M32.674 48.21c1.17-.035 2.256-.227 2.823-.732 3.375-5.374-.47-19.863-.47-19.863l-5.394-2.486-6.854 4.68-.392 9.71a8.153 8.153 0 0 0 3.061 6.697c2.17 1.332 4.679 2.071 7.226 1.994"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M32.748 26.003c1.29 4.33-10.194 9.355-10.194 9.355l-2.885-5.405 5.273-6.456 6.664 1.064s.92.719 1.142 1.442"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343434",
    d: "M32.821 26.915c.241 1.708 2.906 3.78 2.906 3.78l.253-2.042-.61-1.434-1.368-.76s-1.422-1.253-1.18.456m-18.101 94.002s-21.654 9.064-10.615 65.951c.646 3.331.236 6.806-.724 10.063-4.673 15.868-2.026 54.652-2.026 54.652h7.291s24.41-101.217 25.985-130.666h-19.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M81.831 96.23c.37.178 1.69.672 4.466.219 2.492-.407 7.389-2.873 7.06-.047-1.987 1.944-4.094 4.485-4.094 4.485-1.315 1.047-4.125 1.03-5.886.67l-5.307-1.8s-1.09-2.63-1.162-2.743l.923-.721c1.344.206 2.694.17 4-.064"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M82.96 97.16s.112.106.35.245c-.289.22-.56.457-.823.7-1.266.366-2.52.77-3.783 1.15-.122-.806-.298-1.937-.323-2.016l7.747-4.232s.91.76-.347 2.151a8.36 8.36 0 0 1-2.821 2.003"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6B58E",
    d: "M12.456 61.46c7.936-8.174 23.071 12.044 28.504 18.003a11.523 11.523 0 0 0 3.568 2.64L80.82 96.209l-2.28 3.747-40.019-8.563a15.662 15.662 0 0 1-4.407-1.968C26.55 84.527 4.552 69.604 12.456 61.46"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F39F85",
    d: "M39.582 90.835l17.891 3.787-.361.72-17.703-3.744a15.987 15.987 0 0 1-4.607-1.81c-4.044-2.366-10.474-7.2-16.32-11.987.202-.183.398-.372.59-.56 6.145 5.013 12.902 9.984 16.129 11.87a15.235 15.235 0 0 0 4.38 1.724"
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "grayscale"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeet);
export default __webpack_public_path__ + "static/media/meet.050a6d7a82a135b636789a60764d8337.svg";
export { ForwardRef as ReactComponent };